import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { getClickAttrs } from '../Analytics/gtag';

import styles from './headerMenu.scss';

class HeaderMenu extends Component {
    constructor(props) {
        super(props);

        this.handleAchorClick = this.handleAchorClick.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.menuItemClick = this.menuItemClick.bind(this);
        this.setDisablerRef = this.setDisablerRef.bind(this);
        this.state = {
            isMenuShowed: false,
            displayMenuBelowAnchor: true,
            menuStyle: {},
        };
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('touchend', this.handleClickOutside, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('touchend', this.handleClickOutside, false);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    setDisablerRef(node) {
        this.disablerRef = node;
    }

    handleClickOutside(event) {
        if (this.disablerRef?.contains(event.target) && this.state.isMenuShowed) {
            event.preventDefault();
            event.stopPropagation();
            this.setState({
                isMenuShowed: false,
            }, () => {
                this.props.menuClosed();
            });
        } else if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isMenuShowed) {
            this.setState({
                isMenuShowed: false,
            }, () => {
                this.props.menuClosed();
            });
        }
    }

    handleAchorClick(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        const rect = ev.target.getBoundingClientRect();
        const parentRect = ev.target.parentElement.getBoundingClientRect();

        const menuStyle = {};

        const width = parseInt(this.props.width);
        const top = parentRect.bottom + 13;
        if (this.props.showFullWidth) {
            menuStyle.width = '100%';
            menuStyle.position = 'fixed';
            menuStyle.top = `${top}px`;
            menuStyle.height = `calc(100% - ${top}px)`;
        } else {
            menuStyle.width = `${width}px`;
        }

        let alignToRight = false;
        if (rect.right > window.innerWidth / 2) {
            alignToRight = true;
        }

        let showBelow = true;
        if (ev.nativeEvent.clientY > (2 * window.innerHeight / 3)) {
            showBelow = false;
        }

        if (alignToRight) {
            menuStyle.right = `0px`;
        } else {
            menuStyle.left = `0px`;
        }

        this.setState({
            isMenuShowed: true,
            displayMenuBelowAnchor: showBelow,
            menuStyle,
        }, () => {
            this.props.menuOpened();
        });
    }

    menuItemClick(option) {
        return (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            // eslint-disable-next-line no-underscore-dangle
            const _this = this;
            this.setState({
                isMenuShowed: false,
            }, () => {
                _this.props.menuClosed();
                _this.props.onOptionSelected(option, ev);
            });
        };
    }

    render() {
        const {
            options,
            onOptionSelected,
            menuOpened,
            menuClosed,
            showFullWidth,
            children,
            ...domProps
        } = this.props;

        return (
            <div className={`menu-root ${styles.headerMenu}`} {...domProps}>
                <div
                    className="menu-anchor"
                    onClick={this.handleAchorClick}
                >
                    {children || ''}
                </div>
                {this.state.isMenuShowed && (
                    <div
                        className="anchor-click-disabler"
                        ref={this.setDisablerRef}
                    />
                )}
                {this.state.isMenuShowed && (
                    <div
                        className={`menu-container utr-card ${this.state.displayMenuBelowAnchor ? 'below-anchor' : 'above-anchor'}`}
                        style={this.state.menuStyle}
                        ref={this.setWrapperRef}
                    >
                        <div
                            className="menu utr-card"
                        >
                            {options?.map((option) => {
                                return (
                                    option ? (
                                        <div
                                            key={option.id}
                                            className="option"
                                            onClick={this.menuItemClick(option)}
                                            {...getClickAttrs({
                                                category: 'Header',
                                                context: option.label,
                                                location: 'Header Menu CTA',
                                                testid: option.testid,
                                            })}
                                        >
                                            <i className={option.imgClass} />
                                            {option.label}
                                        </div>
                                    ) : null
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

HeaderMenu.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        imgClass: PropTypes.string,
        testid: PropTypes.string,
    })).isRequired,
    onOptionSelected: PropTypes.func,
    menuOpened: PropTypes.func,
    menuClosed: PropTypes.func,
    width: PropTypes.string,
    showFullWidth: PropTypes.bool,
    children: PropTypes.node,
};

HeaderMenu.defaultProps = {
    onOptionSelected: () => {},
    menuOpened: () => {},
    menuClosed: () => {},
    width: '200',
    showFullWidth: false,
    children: null,
};

export default HeaderMenu;
